import { useState, useRef, useEffect } from "react";

export default function ServiceDetailPerform() {
    const galleryRef = useRef(null);
    const [inView, setInView] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
        const el = galleryRef.current;
        if (!el || inView) return;

        const rect = el.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
            setInView(true);
            }, 500); 
        }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); 

        return () => {
        window.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutRef.current); 
        };
    }, [inView]);

  return (
    <>
    <section className="detailserv-perform">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-12">
                    <div className="line-heading">
                        <div ref={galleryRef} className={`lineeffect ${inView ? "showline" : ""}`}></div>
                        <span>Performance</span>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-head">
                        <h4 className="heading">Engineered for Everyday Elegance</h4>
                        <p>Our modular systems are built for durability, precision, and ease of use, making them as practical as they are beautiful. Each setup is designed to perform flawlessly while maintaining a refined, timeless appeal.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="serv-perform-list">
                        <p>Find out more</p>
                        <ul>
                            <li><span>01</span> Versatile and efficient: configurable layouts for every room and requirement.</li>
                            <li><span>02</span> Smooth transition from floor to wall for a seamless aesthetic.</li>
                            <li><span>03</span> Wide choice of sizes, finishes and hardware for design freedom.</li>
                            <li><span>04</span> Slim joints and tight tolerances for a refined, monolithic look.</li>
                            <li><span>05</span> Design versatility: concealed storage, integrated lighting, and appliance-ready units.</li>
                            <li><span>06</span> Durable, easy-care surfaces engineered for everyday use.</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
